import { h, Component } from 'preact'
import { IoIosFlash, IoIosClose } from 'react-icons/io'
import { accessible } from 'utilities/accessibility'
import * as is from 'utilities/is'

export class PowerWordDefinition extends Component {
    constructor(props) {
        super(props)
    }

    setFocusOnCloseButton = el => {
        requestAnimationFrame(() => {
            el && is.fn(el.focus) && el.focus();
        })
    }

    get confirmationButton() {
        return (
            <button {...this.closeAttrs} className="power-words-confirm-button">Got It</button>
        )
    }

    get closeAttrs() {
        const { onCloseDefinition } = this.props
        
        return {
            ...accessible(onCloseDefinition),
            role: "button",
            ariaLabel: "close definition",
            onClick: onCloseDefinition
        }
    }

    render () {
        const { renderableContent, currentWord, currentWordDefinition, expanded } = this.props
    
        return(
            <div className="power-word-wrapper">
                {renderableContent}
                <div className="power-word-definition">
                    <div className="power-words-header">
                        <IoIosFlash className="power-word-icon"/> 
                        <span className="power-word-header-label">Power Word</span>
                        <div className="close-definition" ref={this.setFocusOnCloseButton} { ...this.closeAttrs }>
                            <IoIosClose />
                        </div>
                    </div>
                    <h2 className="definition-word">
                        {currentWord}
                    </h2>
                    <div className="power-word-definition-text">
                        {currentWordDefinition}
                    </div>
                    
                    {expanded && this.confirmationButton}
                </div>
            </div>
        )
    }
}